import { axiosGet } from 'Redux/axiosHelper'
import { RequestParms } from 'types/globalTypes'

export const getAllJobs = async (params: RequestParms) => {
  const response = await axiosGet(`v1/session`, params)
  return response.data
}
